import React from "react";
import { Accordion, Container, Col, Row, Button } from "react-bootstrap";
import { FaChevronDown, FaQuestionCircle } from "react-icons/fa";
import LandingSection from "../landingSection/LandingSection";
import cars from "../../assets/images/cars.jpg";
import heroPhoto from "../../assets/images/faq.png";
import Footer from "../footer/Footer";
import "../faqVersand/FaqVersand.css";
import NavbarMenu from "../heroSection/NavbarMenu";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SEO from "../SEO";

export default function FaqUmzug() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="TransCirox – FAQ | Häufig gestellte Fragen zum Transport"
        description="Antworten auf häufig gestellte Fragen rund um Versand, Gütertransport und Palettenlieferung bei TransCirox."
        keywords="FAQ Transport, Fragen Versand, Transportfragen, Palettenversand FAQ, Gütertransport FAQ"
      />
      <NavbarMenu />
      <LandingSection
        backgroundImage={heroPhoto}
        showNavbar={true}
        showTopbar={false}
        customHeight="90vh"
        showQuoteForm={false}
        showCTAButton={true}
      >
        <div className="text-white header-content" data-aos="fade-down">
          <h6 className="display-4 fw-bold landing-title">
            <span className="typing-word text-orange">
              {t("umzug.FaqUmzug.hero_title")}
            </span>
          </h6>

          <div className="landing-list">
            <p className="fw-bold text-end">
              {t("umzug.FaqUmzug.hero_description")}
            </p>
          </div>
        </div>

      </LandingSection>
      <section className="py-5 bg-light">
        <Container fluid className="px-4 px-md-5">
          <Accordion defaultActiveKey="">
            {t("umzug.FaqUmzug.faqs", { returnObjects: true }).map(
              (item, index) => (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={index}
                  className="mb-3"
                >
                  <Accordion.Header>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="d-flex align-items-center gap-2">
                        <FaQuestionCircle className="text-orange" />
                        <span className="title-accordion">{item.title}</span>
                      </div>
                      <FaChevronDown className="accordion-icon ms-2" />
                    </div>
                  </Accordion.Header>
                  <Accordion.Body
                    style={{ fontSize: "1rem", lineHeight: "1.7" }}
                  >
                    {item.content}
                  </Accordion.Body>
                </Accordion.Item>
              ),
            )}
          </Accordion>
        </Container>
      </section>
      <p className="fw-bold text-center">{t("umzug.FaqUmzug.answer")}</p>

      <Row>
        <Col className="d-flex justify-content-center p-3">
          <Button
            className="btn btn-orange p-3"
            onClick={() => navigate("/contact")}
          >
            {t("umzug.FaqUmzug.answer_button")}
          </Button>
        </Col>
      </Row>
      <Footer />
    </>
  );
}
